// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)

/** Returns a function, that, as long as it continues to be invoked, will not
 *    be triggered. The function will be called after it stops being called for
 *    N milliseconds. If `immediate` is passed, trigger the function on the
 *    leading edge, instead of the trailing.
 * 
 * @template {Function} F
 * @param {F} func - the function to debounce
 * @param {number} wait - debounce time in milliseconds
 * @param {boolean} immediate - whether to trigger on leading edge or not
 * @returns {F} debounced version of the passed-in function
 */
export default function debounce(func, wait, immediate = false) {
  let timeout;

  return function executedFunction() {
    let context = this;
    let args = arguments;

    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}
